import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ShipActions from "redux-store/ship.redux";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useMapContext } from "hooks";

export default function DrawArea() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { selectedAreaList, setSelectedAreaList } = useMapContext();

  const customAreaList = useSelector(state => state.areaRedux.customAreaList);
  const shipConditions = useSelector(state => state.shipRedux.shipConditions);

  const [selected, setSelected] = useState([]);

  const onChangeValue = (event, area) => {
    let value = event.target.value;
    let list = [...selected];
    const uid = area.uid;
    const existedArea = selectedAreaList?.find(currentArea => currentArea.uid === uid);
    if (Boolean(existedArea)) {
      list.push(value);
      setSelectedAreaList(state => [...state].filter(currentArea => currentArea.uid !== uid));
    } else {
      list = list.filter(item => item !== value);
      setSelectedAreaList(state => [...state, { ...area, type: area.attachment_uid ? "file" : "polygon" }]);
    }
    setSelected(list);
  };

  useEffect(() => {
    dispatch(
      ShipActions.shipSet({
        isChangingFilter: true,
        shipConditions: Object.assign(shipConditions, { custom_area_list: selected }),
      }),
    );
  }, [selected]);

  useEffect(() => {
    if (JSON.stringify(selected?.sort()) !== JSON.stringify(selectedAreaList?.map(area => area.uid)?.sort())) {
      setSelected(selectedAreaList?.map(area => area.uid));
    }
  }, [selectedAreaList]);

  return (
    <FormGroup
      classes={{
        root: classes.selectAreaCheckContainer,
      }}
    >
      {customAreaList.map(item => (
        <FormControlLabel
          key={item.uid}
          control={
            <Checkbox value={item.uid} onChange={e => onChangeValue(e, item)} checked={selected?.includes(item.uid)} />
          }
          label={item.name}
          classes={{
            label: classes.areaName,
          }}
        />
      ))}
    </FormGroup>
  );
}

const useStyles = makeStyles(theme => ({
  selectAreaCheckContainer: {
    marginLeft: 16,
    padding: "0 16px",
    maxHeight: 400,
    flexWrap: "no-wrap",
    border: "1px solid rgba(0, 0, 0, 0.2)",
    borderRadius: "4px",
    overflowY: "scroll",
    "&::-webkit-scrollbar": {
      width: "0.5em",
    },
    "&::-webkit-scrollbar-track": {
      background: "#F1F1F1",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#888",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
    "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
      borderRadius: 8,
    },
  },

  areaName: {
    fontSize: "14px",
    color: "#000",
    lineHeight: "100%",
    display: "flex",
    alignItems: "center",
    userSelect: "none",
  },
}));
